import { styled } from '@mui/system'

export const DefaultShadow = styled('div')({
  background: 'white',
  boxShadow:
    '0 1px 2px 0 rgba(0, 0, 0, 0.08), 0 2px 5px 0 rgba(19, 72, 137, 0.1), 0 0 0 0 rgba(48, 48, 48, 0.03)',
})

//TODO: replace this and delete
